export const GameState = {
  BOOTING: 'BOOTING',
  IDENTITY_LOADING: 'IDENTITY_LOADING',
  MENU: 'MENU',
  PLAYING: 'PLAYING',
  PAUSED: 'PAUSED',
  GAME_OVER: 'GAME_OVER',
  SUBMITTING_SCORE: 'SUBMITTING_SCORE',
  RESULTS: 'RESULTS',
  LEADERBOARD: 'LEADERBOARD',
  ERROR_RECOVERY: 'ERROR_RECOVERY',
};

export class GameStateMachine {
  constructor(initialState = GameState.BOOTING) {
    this.currentState = initialState;
    this.listeners = new Set();

    // Map of legal transitions from each state
    this.transitions = {
      [GameState.BOOTING]: [
        GameState.IDENTITY_LOADING,
        GameState.ERROR_RECOVERY,
      ],
      [GameState.IDENTITY_LOADING]: [
        GameState.MENU,
        GameState.ERROR_RECOVERY,
      ],
      [GameState.ERROR_RECOVERY]: [
        GameState.IDENTITY_LOADING,
        GameState.MENU,
      ],
      [GameState.MENU]: [
        GameState.PLAYING,
        GameState.LEADERBOARD,
        GameState.IDENTITY_LOADING,
      ],
      [GameState.LEADERBOARD]: [
        GameState.MENU,
        GameState.PLAYING,
      ],
      [GameState.PLAYING]: [
        GameState.PAUSED,
        GameState.GAME_OVER,
      ],
      [GameState.PAUSED]: [
        GameState.PLAYING,
        GameState.MENU,
      ],
      [GameState.GAME_OVER]: [
        GameState.SUBMITTING_SCORE,
        GameState.RESULTS,
      ],
      [GameState.SUBMITTING_SCORE]: [
        GameState.RESULTS,
      ],
      [GameState.RESULTS]: [
        GameState.PLAYING,
        GameState.MENU,
        GameState.LEADERBOARD,
        GameState.SUBMITTING_SCORE, // Retry score submission
      ],
    };
  }

  getState() {
    return this.currentState;
  }

  canTransitionTo(nextState) {
    const legalNext = this.transitions[this.currentState] || [];
    return legalNext.includes(nextState);
  }

  transitionTo(nextState, payload = null) {
    if (!this.canTransitionTo(nextState)) {
      console.warn(`[GameStateMachine] Invalid transition from ${this.currentState} to ${nextState}`);
      return false;
    }

    const previousState = this.currentState;
    this.currentState = nextState;

    this.notifyListeners(nextState, previousState, payload);
    return true;
  }

  onStateChange(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  notifyListeners(nextState, previousState, payload) {
    for (const listener of this.listeners) {
      try {
        listener(nextState, previousState, payload);
      } catch (err) {
        console.error('[GameStateMachine] Error in state change listener:', err);
      }
    }
  }
}
